import { ISearchParamName, ISearchParamNameAndValue, SearchParamName } from '@cbridge-packages/routing';

export namespace ValidityFilterParam {
  export const name: ISearchParamName = {
    name: SearchParamName.Filter,
  };

  export function nameAndValue(value: ISearchParamNameAndValue['value']): ISearchParamNameAndValue {
    return {
      ...name,
      value,
    };
  }
}
